import { render, staticRenderFns } from "./ContractRbuSectionFluctuationEditor.vue?vue&type=template&id=165e8296"
import script from "./ContractRbuSectionFluctuationEditor.vue?vue&type=script&lang=js"
export * from "./ContractRbuSectionFluctuationEditor.vue?vue&type=script&lang=js"
import style0 from "./ContractRbuSectionFluctuationEditor.vue?vue&type=style&index=0&id=165e8296&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports